import React, { Component } from "react";
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { LinkContainer } from "react-router-bootstrap";
import { Navbar, Container, NavDropdown, Nav, Dropdown } from "react-bootstrap";
import { BurgerMenuIcon } from '../icons/BurgerMenuIcon';

class NavBarMultiPage extends Component {
    /* PIC Change - added this flag to avoid 
       Warning: Can’t call setState (or forceUpdate) on an unmounted component */
    _isMounted = false;  

    componentDidMount() {
        this._isMounted = true;

        let elem = document.getElementById("navbar");
        document.addEventListener("scroll", () => {
            // if (window.scrollY > 170) {
            /* window.scrollY returns number of pixels scrolled */
            if (window.scrollY > 106 ) {    /* if scrolled more than n pixels (height of navbar) */
                elem.classList.add("is-sticky");
            } else {
                elem.classList.remove("is-sticky");
            }
        });
        if (this._isMounted) {
            let scrollWithOffset = (el, offset) => {
                const elementPosition = el.offsetTop - offset;
                window.scroll({
                    top: elementPosition,
                    left: 0,
                    behavior: "smooth"
                });
            };
            this.setState({ scrollWithOffset });
        }
    }


    componentWillUnmount() {
       this._isMounted = false;              

        /* PIC Change - added this to avoid Warning: Can’t call setState (or forceUpdate) on an unmounted component */
        document.removeEventListener("scroll", () => {
                elem.classList.remove("is-sticky");
        })
    }


    // Handlers 
    closeNavbar() {
        if (window.matchMedia("screen and (max-width: 991px)").matches) {
            document.getElementById("collaspe-btn").click();
        }
    }

    logout = (e) => {
        e.preventDefault();
        this.props.startLogout();  // dispatch logout action
    }

    // Helpers used for rendering JSX

    /* Define JSX for Guest Specifci Links to Login or Sign up */
    guestLinks = () => (
        <div>
            <LinkContainer to="/login">
                <Nav.Link>Log In</Nav.Link>
            </LinkContainer>                                  

            <LinkContainer to="/signup">
                <Nav.Link>Sign Up</Nav.Link>
            </LinkContainer>
        </div>
    );


    // Define JSX for User Specifci Links, replacing Login and Sign up with Log Out
    userLinks = () => (
        <div>
            <LinkContainer to="/logout" onClick={this.logout} >
                <Nav.Link>Log Out</Nav.Link>
            </LinkContainer>                                  
        </div>
    );

  

    render() {

        let { isAuthenticated } = this.props.auth;

        return (
            <React.Fragment>
                <Navbar
                    sticky="top"
                    id="navbar"
                    bg="light"
                    expand="lg"
                    className="navbar navbar-expand-lg navbar-light bg-light"
                    collapseOnSelect={true}
                >
                    <Container>
                        <LinkContainer exact to="/">
                            <Navbar.Brand className="navbar-brand">
                               {/*  Axo<span>lot</span>  */}
                               <div className="rc-flex-container-center">
                               <img className="page-header__logo" src="/images/pitch-in-club-logo.jpg" alt="Logo image" />
                               <p className="page-header__title">PITCH IN <span className="page-header__title-part2">CLUB</span> </p>
                               </div>
                            </Navbar.Brand>
                        </LinkContainer>

                        <Navbar.Toggle
                            aria-controls="basic-navbar-nav"
                            id="collaspe-btn"
                        > 
                            <BurgerMenuIcon />
                        </Navbar.Toggle>

                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="ml-auto">
                            {/* PIC Change  - Replace the "Home" drop down with a simple link 
                                <Dropdown>
                                    <NavDropdown title="Home" id="nav-dropdown">
                                        <LinkContainer exact to="/">
                                            <NavDropdown.Item>
                                                Home Version One
                                            </NavDropdown.Item>
                                        </LinkContainer>
                                        <LinkContainer to="/home-two">
                                            <NavDropdown.Item>
                                                Home Version Two
                                            </NavDropdown.Item>
                                        </LinkContainer>
                                        <LinkContainer to="/home-three">
                                            <NavDropdown.Item>
                                                Home Version Three
                                            </NavDropdown.Item>
                                        </LinkContainer>
                                        <LinkContainer to="/home-four">
                                            <NavDropdown.Item>
                                                Home Version Four
                                            </NavDropdown.Item>
                                        </LinkContainer>
                                        <LinkContainer to="/home-five">
                                            <NavDropdown.Item>
                                                Home Version Five
                                            </NavDropdown.Item>
                                        </LinkContainer>
                                        <LinkContainer to="/home-six">
                                            <NavDropdown.Item>
                                                Home Version Six
                                            </NavDropdown.Item>
                                        </LinkContainer>
                                        <LinkContainer 
                                            to="/home-seven"
                                            onClick={() => window.location.refresh()}
                                        >
                                            <NavDropdown.Item>
                                                Home Version Seven
                                            </NavDropdown.Item>
                                        </LinkContainer>
                                        <LinkContainer to="/one-page-template">
                                            <NavDropdown.Item>
                                                One Page Template
                                            </NavDropdown.Item>
                                        </LinkContainer>
                                    </NavDropdown>
                                    {/* <Dropdown.Menu className="super-colors">
                                        
                                    </Dropdown.Menu> 
                                </Dropdown>
                                */}

                                <LinkContainer to="/">
                                    <Nav.Link>Home</Nav.Link>
                                </LinkContainer>

                                <Dropdown>
                                    <NavDropdown title="Resources" id="nav-dropdown">
                                      {/*
                                        <LinkContainer to="/about">
                                            <NavDropdown.Item>About</NavDropdown.Item>
                                        </LinkContainer>
                                      */}
                                        <LinkContainer to="/home4">
                                            <NavDropdown.Item>PageFour</NavDropdown.Item>
                                        </LinkContainer>
                                        <LinkContainer to="/home5">
                                            <NavDropdown.Item>PageFive</NavDropdown.Item>
                                        </LinkContainer>
                                        <LinkContainer to="/resources/features">
                                            <NavDropdown.Item>Features</NavDropdown.Item>
                                        </LinkContainer>
                                        <LinkContainer to="/resources/type-of-events">
                                            <NavDropdown.Item>Type Events</NavDropdown.Item>
                                        </LinkContainer>
                                        <LinkContainer to="/resources/helping-hands">
                                            <NavDropdown.Item>Helping Hands</NavDropdown.Item>
                                        </LinkContainer>
                                        <LinkContainer to="/resources/contribution-list">
                                            <NavDropdown.Item>Contribution List</NavDropdown.Item>
                                        </LinkContainer>
                                        {/* PIC Change - removed as not needed at this point in time 
                                        <LinkContainer to="/pricing">
                                            <NavDropdown.Item>Pricing</NavDropdown.Item>
                                        </LinkContainer>
                                        */}
                                    </NavDropdown>
                                </Dropdown>

                                <LinkContainer to="/about">
                                    <Nav.Link>About</Nav.Link>
                                </LinkContainer>

                            {/* PIC Change - Remove these two links as they are not needed at this time.
                                <LinkContainer to="/services">
                                    <Nav.Link>Services</Nav.Link>
                                </LinkContainer>

                                <LinkContainer to="/team">
                                    <Nav.Link>Team</Nav.Link>
                                </LinkContainer>
                            */}
                                <LinkContainer to="/faq">
                                    <Nav.Link>Faq</Nav.Link>
                                </LinkContainer>


                                { !isAuthenticated && 
                                  (
                                    <LinkContainer to="/login">
                                        <Nav.Link>Log In</Nav.Link>
                                    </LinkContainer>                                  
                                ) }

                                { !isAuthenticated && 
                                    (
                                    <LinkContainer to="/signup">
                                        <Nav.Link>Sign Up</Nav.Link>
                                    </LinkContainer>
                                ) }

                                { isAuthenticated && 
                                    (
                                    <LinkContainer to="/logout">
                                        <Nav.Link>Log out</Nav.Link>
                                    </LinkContainer>
                                ) }
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
};

const mapDispatchToProps = (dispatch) => ({
    startLogout: () => dispatch(startLogout())
})

// export default NavBarMultiPage;
// export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(NavBarMultiPage));

export default connect(mapStateToProps, mapDispatchToProps)(NavBarMultiPage);



// WEBPACK FOOTER //
// ./src/components/common/NavBarMultiPage.js